import { render, staticRenderFns } from "./OvBlogPostView.vue?vue&type=template&id=78c0d0e2"
import script from "./OvBlogPostView.vue?vue&type=script&lang=js"
export * from "./OvBlogPostView.vue?vue&type=script&lang=js"
import style0 from "./OvBlogPostView.vue?vue&type=style&index=0&id=78c0d0e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports